export default "__VITE_ASSET__CSioePgZ__"